import { TitledHeaderBanner } from '@skoda/k2tools-app-components';
import * as queryString from 'query-string';
import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { FamilyList } from '../../components/family-list';
import { VinSearch } from '../../components/vin-search';
import { OwnersManualsAppContext } from '../../contexts/OwnersManualsContext';
import { ManualType } from '../../enums/manualType';
import { SearchError } from '../../enums/searchError';
import { CarModel } from '../../models';
import { IUrlParameters } from '../../models/urlParameters';
import { ResetScroll } from '../../utils/scrollUtils';
import styles from './styles.scss';

type HomePageProps = RouteComponentProps;

type HomePageState = {
	handleVinReset: () => void;
	textWrapperHeight: number;
	bannerType: string;
};

class HomePage extends React.Component<HomePageProps, HomePageState> {
	static contextType = OwnersManualsAppContext;
	context: React.ContextType<typeof OwnersManualsAppContext>;

	constructor(props: HomePageProps) {
		super(props);
		this.state = {
			textWrapperHeight: 220,
			handleVinReset: () => {},
			bannerType: '',
		};
	}

	componentDidMount() {
		this.context.loadCarModels().then(() => {
			this.context.services.trackingPrepare.trackHomepageView();
			ResetScroll();
		});
		window.addEventListener('resize', this.updateScreenSize);
		document.title = this.context.services.resourceProvider.getText('WebTitle');

		const parseParams = queryString.parse(this.props.location.search);
		const params = parseParams as object as IUrlParameters;
		this.context.validate(params);
	}

	componentDidUpdate() {
		this.updateScreenSize();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.updateScreenSize);
	}

	updateScreenSize = () => {
		let newBannerType;
		if (window.innerWidth > 991) {
			newBannerType = `${this.context.services.config.imgPath}banner-desktop.jpg`;
		} else {
			newBannerType = `${this.context.services.config.imgPath}banner-tablet.jpg`;
		}
		if (this.state.bannerType !== newBannerType) {
			this.setState({ bannerType: newBannerType });
		}
	};

	handleVinSubmit = (vin: string, language: string) => {
		this.context.setTopicPilotData('', '', '');

		this.context
			.loadCarModelByVin(vin)
			.then((model) => {
				this.context
					.loadManuals('', '', null, language, vin)
					.then((result) => {
						if (!result.results.length) {
							throw 'emptyManualsResult';
						}
						if (result.results[0].manualType === ManualType.Digital) {
							const modelFamily = model ? model.modelFamily : '';
							const modelType = model ? model.modelType : '';

							this.context.services.trackingPrepare.trackOpenTPManual(modelFamily, modelType, result.results[0].digitalManual.partNumber);
							this.context.setTopicPilotData(vin, result.results[0].digitalManual.partNumber, result.results[0].digitalManual.uiLanguage);
						} else {
							this.props.history.push(`/Detail?manualLang=${language}&vin=${vin}`, {
								isCurrentModel: true,
							});
						}
					})
					.catch(() => {
						this.context.setError('Search_Error_Title', 'Search_Error_Description');
						this.handleVinError(SearchError.NoManuals, model);
					});
			})
			.catch(() => {
				this.context.setError('Search_Error_Title', 'Search_Error_Description');
				this.handleVinError(SearchError.NoManuals, null);
			});
	};

	handleModelToggle = () => {
		this.state.handleVinReset();
	};

	setHandleVinReset = (func: () => void) => {
		this.setState({ handleVinReset: func });
	};

	handleVinError = (error: SearchError, model: CarModel) => {
		this.context.services.trackingPrepare.trackSearchError(error, model ? model.modelFamily : null, model ? model.modelType : null);
	};

	handleVinErrorForVin = (error: SearchError, vin: string) => {
		this.context
			.loadCarModelByVin(vin)
			.then((model) => this.handleVinError(error, model))
			.catch(() => {
				this.context.services.trackingPrepare.trackSearchError(error, null, null);
			});
	};

	render() {
		const { resourceProvider } = this.context.services;
		return (
			<div className={`${styles['container-homepage']}`}>
				<div className={styles['banner-wrapper']}>
					<TitledHeaderBanner img={this.state.bannerType}>{resourceProvider.getText('Car_manual')}</TitledHeaderBanner>
				</div>
				<div id='container-track-scroll'>
					<VinSearch
						{...this.props}
						onlyLanguage={false}
						onSubmit={this.handleVinSubmit}
						setVinReset={this.setHandleVinReset}
						defaultVinCode={this.context.urlParameters?.vin ?? null}
						onError={this.handleVinErrorForVin}
						hasVinError={this.context.errorCode === SearchError.UnrecoginzedVin}
					/>
					<FamilyList {...this.props} onModelToggle={this.handleModelToggle} />
				</div>
			</div>
		);
	}
}

export default HomePage;
